import { gql } from "apollo-angular";

const ADD_NO_MATCH = gql`
          mutation AddNoMatch($productId: Long!) {
            addNoMatch(addNoMatch: { fromProductId: $productId }) {
              id
              createdByOrg {
                id
                name
              }
              createdByOrgType
              crossReferenceDescription
              crossReferenceType
              toProduct {
                seller {
                  id
                  name
                }
                sysSeller {
                  id
                  name
                }
              }
            }
          }
        `;

export default ADD_NO_MATCH;